// React
import React from 'react'
import validator from 'validator'
// GraphQL
import { compose, graphql } from 'react-apollo'
// GraphQL Mutations
import { passwordResetTriggerMutation, passwordResetMutation } from '../../graphql/mutations/account'
// Components
import Button from '../Display/Button'
import HomeButton from '../Nav/HomeButton'
import Input from '../Display/Input'
import Loading from '../Display/Loading'
import Logo from '../Display/Logo'
import Modal from '../Display/Modal'

class Reset extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			email: '',
			passwordResetToken: '',
			loading: { status: false, text: '' },
			password: '',
			passwordAgain: '',
			modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null }, loading: false },
			message: { text: '', color: '' }
		}
	}

	componentWillMount() {
		// Set state with url email and token, if any: https://mywebsite.com/reset?token=TOKEN&email=EMAIL
		let query = Object.assign({}, ...window.location.search.slice(1).split('&').map((item) => {
			const property = item.split('=')[0]
			return { [property]: item.split('=')[1] }
		}))
		if (query.email && query.token) {
			this.setState({ email: query.email, passwordResetToken: query.token })
		}
	}


	// FUNCTIONS
	triggerResetPassword = () => {
		const { email } = this.state
		this.setState({ loading: { status: true, text: 'Sending email...' } })
		this.props.passwordResetTrigger({ variables: { email } })
			.then(() => {
				this.setState({
					loading: { status: false, text: '' },
					modal: {
						status: 'visible',
						title: 'Password Reset',
						text: 'Please check your email address for a password reset link. The password reset link expires in 24 hours.',
						action: { text: 'Continue', func: () => {
							this.closeModal()
							this.props.redux.nav.setPage('')
						} },
						cancel: { text: null, func: null },
						loading: false
					}
				})
			})
			.catch((err) => this.errorHandling(err))
	}

	resetPassword = () => {
		const { passwordResetToken, email, password } = this.state
		this.setState({ loading: { status: true, text: 'Resetting password...' } })
		this.props.passwordReset({ variables: { passwordResetToken, password } })
			.then(() => {
				this.setState({
					loading: { status: false, text: '' },
					modal: {
						status: 'visible',
						title: 'Password Reset',
						text: 'Password successfully reset for ' + email,
						action: { text: 'Continue', func: () => {
							this.closeModal()
							this.props.redux.nav.setPage('')
						} },
						cancel: { text: null, func: null },
						loading: false
					}
				})
			})
			.catch((err) => this.errorHandling(err))
	}

	errorHandling = (err) => {
		let errorMessage = err.toString().split(':')
		errorMessage = errorMessage[errorMessage.length-1].substr(1)
		if (errorMessage === 'Token expired') {
			this.setState({
				loading: { status: false, text: '' },
				modal: {
					status: 'visible',
					title: 'Token expired',
					text: 'Your password has to be reset within 24 hours. Would you like us to send a new password reset link to your email address?',
					action: { text: 'Yes', func: () => {
						this.closeModal()
						this.triggerResetPassword()
					} },
					cancel: { text: 'No', func: null },
					loading: false
				},
				password: '', passwordAgain: ''
			})
		}
		else {
			this.setState({
				loading: { status: false, text: '' },
				modal: {
					status: 'visible',
					title: 'Error',
					text: 'Please contact customer support at support@consciousapps.com for further assistance.',
					action: { text: 'Continue', func: () => this.closeModal() },
					cancel: { text: null, func: null },
					loading: false
				}
			})
			console.error(err)
		}
	}


	// VALIDATORS
	validateTrigger = () => (validator.isEmail(this.state.email))

	validateReset = () => (this.state.password.length >= 6 && this.state.password === this.state.passwordAgain)


	// MODAL
	closeModal = () => this.setState({ modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null } } })



	// INPUT HANDLERS
	handleInput = (name, value) => {
		this.setState({ [name]: value })
		if (name === 'passwordAgain') {
			if (((name === 'password' && this.state.passwordAgain !== value) || (name === 'passwordAgain' && this.state.password !== value)) && value.length >=6) {
				this.setState({ message: { text: 'Password does not match', color: '#FF0000' } })
			} else {
				this.setState({ message: { text: '', color: '' } })
			}
		}
	}

	handleKeyPress = (e) => {
		if (e.charCode === 13) {
			const { passwordResetToken } = this.state
		 	if (!passwordResetToken) {
				if (this.validateTrigger()) {
					this.triggerResetPassword()
				}
			}
			else {
				if (this.validateReset()) {
					this.resetPassword()
				}
			}
		}
	}


	// RENDERS
	// Initial password reset where user enters email. Url is like this: https://mywebsite.com/reset.
	renderTrigger = () => (
		<div className='capps-container'>
			<div className='capps-header'>Password Reset</div>
			<Input
				focus={true}
				label='Email'
				name='email'
				onChange={(name, value) => this.handleInput(name, value)}
				onKeyPress={(e) => this.handleKeyPress(e)}
				type='email'
				value={this.state.email}
			/>
			<Button
				action={this.validateTrigger() ? () => this.triggerResetPassword() : null}
				disabled={!this.validateTrigger()}
				text='Send reset link via email'
			/>
		</div>
	)

	// Subsequent password reset, called once user clicks on link in email, where user enters new password. Url is like this: https://mywebsite.com/reset?token=TOKEN&email=EMAIL
	renderReset = () => (
		<div className='capps-container'>
			<div className='capps-header'>Password Reset</div>
			<Input
				focus={true}
				label='New password (at least 6 characters)'
				name='password'
				onChange={(name, value) => this.handleInput(name, value)}
				type='password'
				value={this.state.password}
			/>
			<Input
				label='New password (verify)'
				name='passwordAgain'
				onChange={(name, value) => this.handleInput(name, value)}
				onKeyPress={(e) => this.handleKeyPress(e)}
				type='password'
				value={this.state.passwordAgain}
			/>
			<Button
				action={this.validateReset() ? () => this.resetPassword() : null}
				disabled={!this.validateReset()}
				text='Reset password'
			/>
		</div>
	)

	renderSection = () => (!this.state.passwordResetToken ? this.renderTrigger() : this.renderReset())


	render() {
		const { loading, message, modal } = this.state
		return (
			<div className='capps-responsive'>
				<HomeButton {...this.props} />
				<Loading status={loading.status} text={loading.text} />
				<Modal
					status={modal.status}
					title={modal.title}
					text={modal.text}
					action={{ text: modal.action.text, func: modal.action.func }}
					cancel={{ text: modal.cancel.text, func: modal.cancel.func }}
					loading={modal.loading}
				/>
				<Logo {...this.props} />
				{this.renderSection()}
				<div className='capps-footer' style={{ color: message.color, fontWeight: '400' }}><center>{message.text}</center></div>
			</div>
		)
	}
}

export default compose(
	graphql(passwordResetTriggerMutation, { name: 'passwordResetTrigger' }),
	graphql(passwordResetMutation, { name: 'passwordReset' })
)(Reset)



// WEBPACK FOOTER //
// ./src/Components/Auth/Reset.js